<template>
  <div class="student">
    <van-nav-bar
      title="选择学生"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <van-cell-group class="c-margin-top-normal">
      <van-cell
        v-for="(item, index) in studentList"
        :title="item.Studentname"
        is-link
        icon="customiz iconfont icon-xuesheng"
        @click="changeStudent(item)"
        :key="index"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { NavBar, Cell, CellGroup, Toast } from 'vant'

export default {
  data() {
    return {
      studentList: []
    }
  },
  created() {
    this.$http
          .json_post(this.$api.baseinfo.getchildlist, {
            
          })
          .then(data => {
            if (data.code == 0) {
             this.studentList = data.data;
            }else{
              Toast(data.msg);
            }
          })
  },
  methods: {
    changeStudent(item) {
      if (item) {
        localStorage.setItem('currentChild',JSON.stringify(item))
        this.$router.push({ name: 'my' })
      }
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-cell-group': CellGroup,
    'van-cell': Cell
  }
}
</script>

<style lang="scss" scoped>
.icon-xuesheng {
  color: $primary-color;
}
</style>
